import { useQuery } from '@tanstack/react-query'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import Header from '@components/header'
import Layout from '@components/Layout'
import ActSverkaForClients from '@components/Modal/AktSverka/ActSverkaForClients'
import ActSverkaInfo from '@components/Modal/AktSverka/AktSverkaInfo'
import CreateUserModal from '@components/Modal/createUserModal'
import ViewSuppliersModal from '@components/Modal/viewSuppliersModal'
import { columnSupplier } from '@utils/columns'
import { debouncedSet } from '@utils/debounce'
import { fetchSuppliers } from '@utils/fetchData'

const Suppliers = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()

	const [currentPage, setCurrentPage] = useState(0)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [selectedViewRowData, setSelectedViewRowData] = useState(null)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [cardName, setCardName] = useState('')
	const [phoneNum, setPhoneNum] = useState('')
	const [isAktSverkaModalVisible, setIsAktSverkaModalVisible] =
		useState(false)

	const [isAktSverkaInfoModalVisible, setIsAktSverkaInfoModalVisible] =
		useState(false)

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['suppliers', cardName, phoneNum, currentPage],
		queryFn: fetchSuppliers,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleRowClick = (record) => {
		setSelectedRowData(record)
		setIsModalVisible(true)
	}
	const handleViewRowClick = (record) => {
		setSelectedViewRowData(record)
		setIsViewModalVisible(true)
	}

	const handleCardNameNameChange = (val) => {
		debouncedSet(val, setCardName)
	}
	const handlePhoneNumberChange = (val) => {
		debouncedSet(val, setPhoneNum)
	}
	const handleSeeBtnClick = (record) => {
		// navigate(`/see-sales`)
		// localStorage.setItem('cardCode', cardCode)
		// console.log('localStorageCardCode', cardCode)
		setSelectedRowData(record)
		setIsAktSverkaModalVisible(true)
	}
	const handleActSverkaInfoClick = (record) => {
		// navigate(`/see-sales`)
		// localStorage.setItem('cardCode', cardCode)
		// console.log('localStorageCardCode', cardCode)
		setSelectedRowData(record)
		setIsAktSverkaInfoModalVisible(true)
	}

	const columns = columnSupplier(
		t,
		handleViewRowClick,
		handleCardNameNameChange,
		handlePhoneNumberChange,
		handleSeeBtnClick,
		handleActSverkaInfoClick,
	)

	return (
		<Layout>
			<Header
				title={'suppliers'}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				onBtnClick={handleRowClick}
				isSticky={false}

			/>
			<CreateUserModal
				visible={isModalVisible}
				onClose={() => {
					setIsModalVisible(false)
					setCurrentPage(0)
					refetch()
				}}
			/>
			<ViewSuppliersModal
				visible={isViewModalVisible}
				data={selectedViewRowData}
				onClose={() => setIsViewModalVisible(false)}
			/>
			<ActSverkaForClients
				visible={isAktSverkaModalVisible}
				onClose={() => setIsAktSverkaModalVisible(false)}
				data={selectedRowData}
			/>
			<ActSverkaInfo
				visible={isAktSverkaInfoModalVisible}
				onClose={() => setIsAktSverkaInfoModalVisible(false)}
				datas={selectedRowData}
			/>
		</Layout>
	)
}

export default Suppliers
